import {
  CreateSamlIdentityProviderDto,
  SamlIdentityProviderDto,
  SamlIdentityProvidersApi,
} from '../../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../../common/types/errorRespose';
import { UseMutationOptions } from 'react-query/types/react/types';
import { getApiConfiguration } from '../../../../common';

type UseCreateSamlProvider = (
  options?: Omit<UseMutationOptions<AxiosResponse<SamlIdentityProviderDto>,
    ErrorResponse,
    CreateSamlIdentityProviderDto>,
    'mutationFn'>,
) => UseMutationResult<AxiosResponse<SamlIdentityProviderDto>,
  ErrorResponse,
  CreateSamlIdentityProviderDto>;

export const useCreateSamlProvider: UseCreateSamlProvider = (
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const samlIdentityProvidersApi = new SamlIdentityProvidersApi(getApiConfiguration());
  return useMutation(
    (createSamlIdentityProviderDto: CreateSamlIdentityProviderDto) =>
      samlIdentityProvidersApi.createSamlProvider(tenantId, createSamlIdentityProviderDto),
    options,
  );
};
